<script setup>
import { onMounted, ref } from "vue";
import apiClient from "@/apiClient";
import { useRouter } from "vue-router";

const router = useRouter();

const registrationNumber = ref("");
const vehicleTypeId = ref("");
const vehicleTypes = ref([]);
const saveBtnActive = ref(true);

const loadVehicleTypes = async () => {
  const response = await apiClient.get("/api/vehicle-types");
  vehicleTypes.value = (response.data ?? []).filter((type) => type.active);
  vehicleTypeId.value =
    vehicleTypes.value.find((type) => type.slug === "generic")?.id ??
    vehicleTypes.value[0]?.id ??
    "";
};

const addVehicle = async () => {
  if (registrationNumber.value.length < 3) {
    return alert("Registration number must be longer");
  }
  if (!vehicleTypeId.value) {
    return alert("Please choose a vehicle type");
  }
  saveBtnActive.value = false;
  try {
    await apiClient.post("/api/vehicle", {
      registrationNumber: registrationNumber.value,
      vehicle_type_id: Number(vehicleTypeId.value),
    });
    router.push({ name: "dashboard-fleet" });
  } finally {
    saveBtnActive.value = true;
  }
};

onMounted(loadVehicleTypes);
</script>
<template>
  <form-box header="Add Vehicle">
    <div class="grid max-w-xl gap-4 sm:grid-cols-2">
      <label>
        <span>Registration Number</span>
        <input
          type="text"
          class="mt-1 w-full uppercase"
          v-model="registrationNumber"
          :disabled="!saveBtnActive"
        />
      </label>
      <label>
        <span>Vehicle Type</span>
        <select
          v-model="vehicleTypeId"
          class="mt-1 w-full"
          :disabled="!saveBtnActive"
        >
          <option value="" disabled>Select a type</option>
          <option v-for="type in vehicleTypes" :key="type.id" :value="type.id">
            {{ type.name }}
          </option>
        </select>
      </label>
    </div>
    <div class="mt-4">
      <button
        class="btn save"
        :disabled="!saveBtnActive"
        @click.prevent="addVehicle"
      >
        {{ saveBtnActive ? "Save" : "Saving..." }}
      </button>
    </div>
  </form-box>
</template>
